import React, { ReactNode } from "react";
import styles from "./styles/transparent-button.module.scss";
import { Property } from "csstype";

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  border?: Property.Border;
  children: ReactNode;
};

const TransparentButton = ({ onClick, disabled, border, children }: Props) => (
  <button
    className={disabled ? styles.button_disabled : styles.button}
    style={{ border: border || "0.8px solid #f2f2f2" }}
    type="button"
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </button>
);

export default TransparentButton;
